import { useCallback, useEffect, useRef } from "react";
import { useBlocker } from "react-router-dom";
import useToastConfirmation from "../components/common/toasts/useToastConfirmation";

/** Chroni korekty przed menu, historią routera i zamknięciem strony. */
export default function useUnsavedChanges(dirty) {
  const { confirm, cancel } = useToastConfirmation();
  const dirtyRef = useRef(dirty);
  dirtyRef.current = dirty;
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) =>
        dirtyRef.current &&
        (currentLocation.pathname !== nextLocation.pathname ||
          currentLocation.search !== nextLocation.search),
      [],
    ),
  );
  const blockerRef = useRef(blocker);
  blockerRef.current = blocker;
  useEffect(() => {
    if (blocker.state !== "blocked") return;
    let active = true;
    confirm("Masz niezapisane zmiany. Opuścić stronę i je odrzucić?", {
      acceptLabel: "Odrzuć zmiany i wyjdź",
      cancelLabel: "Zostań na stronie",
    }).then((accepted) => {
      if (!active || blockerRef.current.state !== "blocked") return;
      if (accepted) blockerRef.current.proceed();
      else blockerRef.current.reset();
    });
    return () => {
      active = false;
      cancel();
    };
  }, [blocker.state, confirm, cancel]);
  useEffect(() => {
    const beforeUnload = (event) => {
      if (!dirtyRef.current) return;
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", beforeUnload);
    return () => window.removeEventListener("beforeunload", beforeUnload);
  }, []);
  return useCallback(() => {
    dirtyRef.current = false;
  }, []);
}
